<template>
    <!-- /my-task-manager: a link anyone can be sent (no employee ID or slug in it). Opens your task manager,
         or Decks when you don't have one set up yet. Signed out, App.vue sends you to log in and back here. -->
    <div class="page-wrap"></div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import axios from 'axios';

export default defineComponent({
    name: 'MyTaskManager',
    async created() {
        // The session is checked in App.vue; until then the API doesn't know who you are
        while(!this.$store.state.signedIn) {
            await new Promise(resolve => setTimeout(resolve, 100));
            if(this.$route.name != 'MyTaskManager') {
                return;
            }
        }
        let slug = '';
        await axios.get(`${this.$store.state.apiUrl}/api/companyboards/taskmanager`)
            .then(resp => {
                slug = resp.data?.board?.Slug || '';
            })
            .catch(e => {
                console.log(e);
            })
        this.$router.replace(slug ? '/deck/' + slug : '/decks');
    }
});
</script>
